import {computed, ComputedRef, ref, Ref} from "vue";
import CommonUtils from "@/utils/CommonUtils.ts";
import {ButtonProps} from "@nuxt/ui/components/Button.vue";

class ButtonActionKlass {
  private static _instance: ButtonActionKlass;
  private _isButtonClicked: Ref<boolean> = ref(false);

  static getInstance(): ButtonActionKlass {
    if (!this.instance)
      this.instance = new ButtonActionKlass();
    return this.instance;
  }

  isButtonDisabled(): ComputedRef<boolean> {
    return computed(() => this._isButtonClicked.value)
  }

  getDisabledButtonProp(...moreConditions: boolean[]): ComputedRef<any> {
    return computed(() => ({
      disabled: this.isButtonDisabled().value || moreConditions.some(c => Boolean(c))
    }))
  }

  getDisabledButtonProps(...moreConditions: boolean[]): ComputedRef<any> {
    return computed(() => ({...this.getDisabledButtonProp(...moreConditions).value, ...this.getDisabledButtonUI()}))
  }

  getDisabledButtonUI(): ButtonProps {
    return {
      ui: {
        base: 'ui-disabled-btn'
      },
      loading: this.isButtonDisabled().value,
      loadingIcon: "i-lucide-loader"
    }
  }

  async performAction(action: () => Promise<void>) {
    this._isButtonClicked.value = true;
    try {
      await action();
    } catch (e) {
    } finally {
      await CommonUtils.waitFor(10);
      this._isButtonClicked.value = false;
    }
  }


  static get instance(): ButtonActionKlass {
    return this._instance;
  }

  static set instance(value: ButtonActionKlass) {
    this._instance = value;
  }

  get isButtonClicked(): Ref<boolean> {
    return this._isButtonClicked;
  }

  set isButtonClicked(value: Ref<boolean>) {
    this._isButtonClicked = value;
  }
}

export const ButtonAction = ButtonActionKlass.getInstance();